module.exports = __webpack_public_path__ + "img/ic_star_gray_24px@2x.7dea31f2.png";